<template>
  <Popup v-model="showPopup" :popup-header="popupHeader" popup-size="lg" header-class="text-h3" @close="handleClose">
    <RecruitSitter
      v-if="showPopup"
      ref="recruitSitter"
      :account="account"
      :recipient-uuid="sitterUuid"
      :recipient-name="sitterName"
      :search-care-type="searchCareType"
      :jobs="parentJobs"
      :is-popup-mode="true"
      @success="handleSuccess"
      @continue-searching="handleContinueSearching"
    />
  </Popup>
</template>

<script lang="ts">
import { PropType } from 'vue';
import Popup from '@/components/popup/Popup.vue';
import RecruitSitter from '@/apps/messages/new/RecruitSitter.vue';
import { Account } from '@/models/account';
import { JobEdge } from '@/graphql/search/queries';
import type { SuccessPayload } from '@/apps/messages/new/types';

export default {
  name: 'RecruitSitterPopup',
  components: {
    Popup,
    RecruitSitter,
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    account: {
      type: Object as PropType<Account>,
      required: true,
    },
    sitterUuid: {
      type: String,
      required: true,
    },
    sitterName: {
      type: String,
      required: true,
    },
    searchCareType: {
      type: String,
      default: '',
    },
    parentJobs: {
      type: Array as PropType<JobEdge[]>,
      default: () => [],
    },
  },
  data() {
    return {
      showPopup: this.modelValue,
    };
  },
  computed: {
    popupHeader(): string {
      return `Invite ${this.sitterName} to apply`;
    },
  },
  watch: {
    modelValue(newVal: boolean) {
      this.showPopup = newVal;
    },
    showPopup(newVal: boolean) {
      this.$emit('update:modelValue', newVal);
    },
  },
  methods: {
    handleSuccess(payload: SuccessPayload) {
      if (!payload.recruited) {
        return;
      }
      this.$emit('sitterRecruited', payload.recipientUuid);
    },
    handleContinueSearching() {
      this.handleClose();
    },
    handleClose() {
      this.showPopup = false;
    },
  },
};
</script>
